import './NoOffersBanner.css';

import React from 'react';
import { Typography } from '@vtblife/uikit';

import classname from '@search/classname/src';
import { useStaticPathConfig } from '@search/common-core/src/StaticPathContext';

import Image from '../../../Image';
import NoOffersImg from './NoOffersImg.url.svg';

const cn = classname.bind(null, 'NoOffersBanner');

export const NoOffersBanner = () => {
    const staticPath = useStaticPathConfig();

    return (
        <div className={cn()}>
            <Image url={`${staticPath}${NoOffersImg}`} />
            <div className={cn('description')}>
                <Typography variant='h4'>
                    Предложений нет
                </Typography>
                <p className={cn('text')}>
                    На&nbsp;таких условиях оформить ипотеку не&nbsp;получится.
                    Попробуйте найти квартиру дешевле или увеличьте срок.
                </p>
            </div>
        </div>
    );
};
